import type { FooterLinkColumn } from '../components/SiteFooter'

/** Static SiteFooter content, shared so every surface carrying the site footer stays in step. */
export const SITE_FOOTER_TAGLINE =
  'Financial technology to empower the businesses that build, move, and fix the world around us.'

export const SITE_FOOTER_LINK_COLUMNS: FooterLinkColumn[] = [
  {
    heading: 'Company',
    links: [
      { label: 'About', href: '/#about' },
      { label: 'Blog', href: 'https://blog.cai.ai', external: true },
    ],
  },
  {
    heading: 'Products',
    links: [
      { label: 'Insurance', href: '/insurance' },
      { label: 'Bookkeeper', href: '/bookkeeper' },
      { label: 'FuelApp', href: '/fuelapp' },
      { label: 'AI CFO', href: '/cfo', tag: 'Beta' },
      { label: 'Compliance', tag: 'Coming soon' },
    ],
  },
  {
    heading: 'Connect',
    links: [
      { label: 'LinkedIn', href: 'https://www.linkedin.com/company/cai-labs-inc', external: true },
      { label: 'Facebook', href: 'https://www.facebook.com/people/Cai/61591707575556/', external: true },
      { label: 'Instagram', href: 'https://www.instagram.com/cai.labs', external: true },
      { label: 'X', href: 'https://x.com/cailabsinc', external: true },
    ],
  },
]

export const SITE_FOOTER_LEGAL_LINKS = [
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
]

const LICENSING_NOTE = (
  <p>
    Insurance services provided by Cai Insurance Services, a service of Cai Labs, Inc. Agency License
    #6018835. Descriptions are general in nature only. Please refer to the terms and conditions of any
    policies offered or purchased. Insurance products offered are subject to application and underwriting
    requirements. Not all products available in all states. Pricing depends on a variety of factors including
    policyholder location. Not all discounts available in all states or on all products.
  </p>
)

export const ACCESSIBILITY_NOTE = (
  <p>
    If you are having difficulty viewing or navigating the content on this website, or find a feature or
    functionality that is not fully accessible to you, please email us at{' '}
    <a href="mailto:hello@cai.ai">hello@cai.ai</a>.
  </p>
)

export const SITE_FOOTER_NOTE = (
  <>
    {LICENSING_NOTE}
    {ACCESSIBILITY_NOTE}
  </>
)

/** The site note plus the indication disclaimer — quotes pages only, where prices are on screen. */
export const QUOTES_FOOTER_NOTE = (
  <>
    {LICENSING_NOTE}
    <p>
      Policy terms and conditions are for informational purposes only and do not represent any actual coverage
      or limit of liability available to you, and no representation of insurance coverage provided to you is
      being made by Cai Insurance Services, LLC. If a policy is issued to you, refer to the policy as issued
      for actual terms and conditions.
    </p>
    {ACCESSIBILITY_NOTE}
  </>
)
